import { html } from 'lit';

// Click/tap-toggleable ⓘ button for a CV rating-scale category. Kept separate from
// ScoreInfoDescription so the button can sit next to the category label while the
// definition expands below the score bar; the caller holds one `useState` per category.
export const ScoreInfoButton = ({
  label,
  expanded,
  onToggle,
}: {
  label: string;
  expanded: boolean;
  onToggle: () => void;
}) => html`
  <button
    type="button"
    class="btn btn-ghost btn-xs btn-circle"
    aria-expanded=${expanded}
    aria-label=${label}
    @click=${onToggle}
  >
    <span class="icon-[material-symbols--info-outline]"></span>
  </button>
`;

export const ScoreInfoDescription = ({ description }: { description: string }) => html`
  <div class="text-sm text-base-content/70 mt-1">${description}</div>
`;
